import React from "react";
import "../../../css/Grupo3/G3Landing.css";
import IndiceTalleres from "../../../Component/Grupo3/IndiceTalleres";

function VistaPrincipal() {
  return (
    <div className="wrapper">
      <IndiceTalleres />
    </div>
  );
}

export default VistaPrincipal;
